<template>
    <div>
        <p><span>Blacklist the <em>{{action.type | unKebabCase}}</em>&nbsp;</span>
            <span v-if="isTemporary">for a period of {{action.ttl | number}} seconds.</span>
            <span v-else>permanently.</span>
        </p>
    </div>
</template>

<script>
    import BaseActionSummary from '../base-action-summary';

    export default {
        name: 'blacklist-summary',
        extends: BaseActionSummary,
        computed: {
            isTemporary() {
                return this.action.ttl !== 0;
            },
        },
    };
</script>

<style scoped>

</style>
